import { Account } from 'domain/model/account'

export type UserInfo = Omit<Account, 'password'> & { token?: string }

export enum UserRole {
  Oncologist = 'Oncologist',
  MedicalAssistant = 'Medical Assistant',
  Reviewer = 'Reviewer',
}

export interface GetUserInfo {
  getUserInfo: () => Promise<UserInfo>
}
